<dashboard-carousel [items]="videos" [headerText]="headerLabel" [headerSref]="headerSref" [headerSrefParams]="headerSrefParams">
		<div *ngFor="let video of videos" class="carousel-cell" [ngClass]="styles.carouselCellItem">
			<video-tile-v2 [ngClass]="[styles.carouselCell, styles.videoTile]" [video]="video" [userId]="UserContext.user.id" [hideVideoStatusText]="true">
			</video-tile-v2>
		</div>
</dashboard-carousel>
